/* ENGEL LOEWE — reveal observer
   Targets any element with .el-reveal-fade or .el-reveal-clip and the
   gold divider. Adds .is-in when ≥15% in viewport. One-way.
   Uses IntersectionObserver — no scroll listeners.
*/
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.el-reveal-fade, .el-reveal-clip, .el-gold-divider')
      .forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var t = entry.target;
      // Stagger group children by .el-reveal-stagger > *
      if (t.classList.contains('el-reveal-stagger')) {
        Array.prototype.forEach.call(t.children, function (child, i) {
          setTimeout(function () { child.classList.add('is-in'); }, i * 80);
        });
      } else {
        t.classList.add('is-in');
      }
      io.unobserve(t);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

  function init() {
    document.querySelectorAll(
      '.el-reveal-fade, .el-reveal-clip, .el-reveal-stagger, .el-gold-divider:not(.no-reveal)'
    ).forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
